import PropTypes from 'prop-types';

const propType = {
  cancellationDate: PropTypes.number,
  createdAt: PropTypes.number,
  startDate: PropTypes.number,
  creditCard: PropTypes.string,
  currentUserPlan: PropTypes.string,
  paymentMethodId: PropTypes.string,
  status: PropTypes.string,
  stripeSubscription: PropTypes.string,
  subscriptionStripeId: PropTypes.string,
  tenant: PropTypes.string,
  organization: PropTypes.string,
  owner: PropTypes.string,
};

export default { propType };
